module.exports = __webpack_public_path__ + "static/media/emerson_interno-new.e1eac8b4.png";